@if (displayDetails(); as details) {
  <div
    class="flex flex-col gap-4 rounded-md border border-solid border-gray-200 p-4"
  >
    <div class="flex items-center justify-between">
      <p class="text-lg font-semibold">{{ title() }}</p>
      <button
        mat-icon-button
        matTooltip="Copy Details"
        (click)="copyDetailsToClipboard()"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>

    <div
      class="grid-label-value grid w-full auto-rows-auto items-start gap-x-6 gap-y-4"
    >
      <span class="font-bold">Name</span>
      <span>{{ details.name }}</span>

      @if (details.jobTitle; as jobTitle) {
        <span class="font-bold">Job Title</span>
        <span>{{ jobTitle }}</span>
      }

      @if (details.practice; as practice) {
        <span class="font-bold">Practice</span>
        <span>{{ practice }}</span>
      }

      @if (details.phone; as phone) {
        <span class="font-bold">Phone</span>
        <span>
          <a [href]="'tel:' + phone">{{ phone }}</a>
        </span>
      }

      @if (details.mobileNumber; as mobileNumber) {
        <span class="font-bold">Mobile</span>
        <span>
          <a [href]="'tel:' + mobileNumber">{{ mobileNumber }}</a>
        </span>
      }

      @if (details.email; as email) {
        <span class="font-bold">Email</span>
        <span>
          <a [href]="'mailto:' + email">{{ email }}</a>
        </span>
      }

      @if (details.address; as address) {
        <span class="font-bold">Address</span>
        <span>{{ address }}</span>
      }
    </div>
  </div>
}
